import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createBlock(_component_el_image_viewer, {
    ref: "imgRef",
    "url-list": _ctx.imageArr,
    "initial-index": 0,
    onClose: _ctx.onClose
  }, null, 8, ["url-list", "onClose"]))
}